const languages = [
    {
        name: 'English',
        code: 'en',
        enabledForUser: true
    },
    {
        code: 'de',
        name: 'Deutsch',
        enabledForUser: true
    },
    {
        name: '中文',
        code: 'zh',
        enabledForUser: true
    }
];

export default languages
